import axios from 'axios'

export const PaymentApi = {
    async ErrorDetail(paymentCode,receiptCode){
        const response = await axios.post(`/api/payment/errordetail/${paymentCode}/${receiptCode}`)
        return response
    },
    async List(data){
        const response = await axios.post('/api/payment/table',data)
        return response
    },
    async DownloadList(data){
        const response = await axios.post('/api/payment/download/paymentlist',data)
        return response
    },
    async GetDetail(data){
        const response = await axios.get(`/api/payment/get/paymentdetail/${data}`)
        return response
    },
    async DateControlForInstallment(data){
        const response = await axios.post('/api/payment/datecontrolforinstallment',data)
        return response
    },
    async CreateResponsibleUserApproveRequest(data){
        const response = await axios.post('/api/payment/createresponsibleuserapproverequest',data)
        return response
    },
    async CreatePaymentRequest(data){
        const response = await axios.post('/api/payment/create/paymentrequest',data)
        return response
    },
    async GetReceipt(data){
        const response = await axios.get(`/api/payment/get/receipt/${data}`)
        return response
    },
    async CurrentDateTotalAmount(){
        const response = await axios.get('/api/payment/get/currentdate/totalamount')
        return response
    },
    async CurrentMonthTotalAmount(){
        const response = await axios.get('/api/payment/get/currentmonth/totalamount')
        return response
    },
    async PaymentRequestList(start,end){
        const response = await axios.get(`/api/payment/get/paymentrequest/list/${start}/${end}`)
        return response
    },
    async PaymentRequestByCode(code){
        const response = await axios.post(`/api/payment/get/paymentrequest/listbycustomer/${code}`)
        return response
    },
    async SalesmanPaymentStatusList(){
        const response = await axios.get('/api/payment/salesmanpaymentstatuslist')
        return response
    },
    async ResponsibleUserPaymentStatusList(){
        const response = await axios.get('/api/payment/responsibleuserpaymentstatuslist')
        return response
    },
    async ApproveInstallment(data){
        const response = await axios.post(`/api/payment/approveinstallmentfromtable/${data}`)
        return response
    },
    async ApproveRequestAgain(data){
        const response = await axios.post(`/api/payment/approverequestagain/${data}`)
        return response
    },
    async PosnetCalculateData(data){
        const response = await axios.post(`/api/payment/posnet/calculateposnetdata`,data)
        return response
    },
    async PreparePayment(data){
        const response = await axios.post(`/api/payment/prepare`,data)
        return response
    },
    async DailyStatsByUser(data){
        const response = await axios.post(`/api/payment/dailystatsbyuser`,data)
        return response
    },
    async DailyStatsByUserTotalAmount(data){
        const response = await axios.post(`/api/payment/dailystatsbyusertotalamount`,data)
        return response
    },
    async CancelPayment(data){
        const response = await axios.post(`/api/payment/cancel/${data}`)
        return response
    }
}